import { render } from "./PhoneSimple.vue?vue&type=template&id=70bdadbc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PhoneSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70bdadbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70bdadbc', __exports__)) {
    api.reload('70bdadbc', __exports__)
  }
  
  module.hot.accept("./PhoneSimple.vue?vue&type=template&id=70bdadbc", () => {
    api.rerender('70bdadbc', render)
  })

}


export default __exports__